export const SHOW_TIMEZONE_NOTIFICATION = 'SHOW_TIMEZONE_NOTIFICATION';
export const HIDE_TIMEZONE_NOTIFICATION = 'HIDE_TIMEZONE_NOTIFICATION';

export const UPDATE_TIMEZONE_NOTIFICATION_STATUS_FROM_STORAGE = 'UPDATE_TIMEZONE_NOTIFICATION_STATUS_FROM_STORAGE';